// extracted by mini-css-extract-plugin
export default {"settings-block":"settings-block--9c49bb","settingsBlock":"settings-block--9c49bb"};